import React, { useLayoutEffect, useMemo } from 'react';

import { Fuse, printMissingConfigError, SiteConfigManager } from '@atlas/core';

import { loadScript } from 'common/utils';

const XcmLicense = ({ iconSize, iconStyle }) => {
  const xcmId = SiteConfigManager.getConfig('config.config.license.xcmId');
  const xcmDomId = SiteConfigManager.getConfig('config.config.license.xcmDomID', 'X42');

  if (!xcmId) {
    printMissingConfigError('config.config.license.xcmId');
  }

  useLayoutEffect(() => {
    const xcmWindowObject = window[xcmDomId.replaceAll('-', '_')];

    if (
      xcmWindowObject &&
      typeof xcmWindowObject === 'object' &&
      typeof xcmWindowObject.init === 'function'
    ) {
      try {
        xcmWindowObject.init();
      } catch (e) {
        console.error("Can't show xcm license");
      }
    } else {
      (async () => {
        await loadScript(`https://${xcmId}.seals-xcm.certria.com/xcm-seal.js`);
      })();
    }
  }, []);

  return useMemo(() => {
    const xcmLicenseDomElement = document.querySelector(`#${xcmDomId}`);

    if (!xcmLicenseDomElement) {
      return (
        <div
          className="e-gaming-logo"
          data-xcm-image-size={iconSize}
          data-xcm-image-type="basic-small"
          data-xcm-seal-id={xcmId}
          id={xcmDomId}
          style={iconStyle}
        />
      );
    }

    return (
      <div
        className="e-gaming-logo"
        dangerouslySetInnerHTML={{ __html: xcmLicenseDomElement.innerHTML }}
      />
    );
  }, []);
};

const fallback = () => <div />;

export default function (props) {
  return (
    <Fuse fallback={fallback}>
      <XcmLicense {...props} />
    </Fuse>
  );
}
